import React, { useEffect, useRef } from 'react';

export default function ContextMenu({ x, y, items, onClose }) {
  const ref = useRef();

  useEffect(() => {
    const down = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    const key  = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('mousedown', down);
    document.addEventListener('keydown', key);
    return () => { document.removeEventListener('mousedown', down); document.removeEventListener('keydown', key); };
  }, [onClose]);

  // Clamp to viewport
  const left = Math.min(x, window.innerWidth  - 220);
  const top  = Math.min(y, window.innerHeight - 40);

  return (
    <div className="context-menu" ref={ref} style={{ left, top }}>
      {items.map((item, i) => {
        if (item.divider) return <div key={i} className="context-menu-divider" />;
        if (item.type === 'section') return <div key={i} className="context-menu-section">{item.label}</div>;

        if (item.type === 'palette') {
          return (
            <div key={i} className="context-menu-palette">
              <div className="context-menu-palette-label">{item.label}</div>
              <div className="context-menu-colors">
                {item.colors.map(c => (
                  <div
                    key={c.value}
                    className={`context-menu-swatch ${item.active === c.value ? 'active' : ''}`}
                    style={{ background: c.value }}
                    title={c.name}
                    onClick={() => { item.onSelect(c.value); onClose(); }}
                  />
                ))}
                <div
                  className="context-menu-swatch reset"
                  title="Reset to default"
                  onClick={() => { item.onSelect(null); onClose(); }}
                >×</div>
              </div>
            </div>
          );
        }

        return (
          <button
            key={i}
            className={`context-menu-item ${item.danger ? 'danger' : ''} ${item.soon ? 'soon' : ''}`}
            onClick={() => { if (!item.soon) { item.onClick(); onClose(); } }}
          >
            {item.icon && <span className="ctx-icon">{item.icon}</span>}
            <span className="ctx-label">{item.label}</span>
            {item.soon && <span className="ctx-soon">Soon</span>}
          </button>
        );
      })}
    </div>
  );
}
